// @ts-ignore
import template from "./widget.html";
import css from "./widget.css";
import { openMenu } from "../menu/menu";
import translateWidget from "../menu/translateWidget";

import {
    pluginConfig
} from "@/globals/pluginConfig";

export let $widget: HTMLElement;

export function renderWidget() {
    $widget = document.createElement("div");
    $widget.classList.add("asw-container");
    $widget.innerHTML = `<style>${css}</style>${template}`;

    const $btn: HTMLElement = $widget.querySelector(".asw-menu-btn");
    const $icon: HTMLElement | null = $btn?.querySelector("svg");
    Object.assign($btn.style, getButtonStyle());
    applyIconSize($icon);
    
    $btn?.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        openMenu();
    });

    translateWidget();

    document.body.appendChild($widget);

    return $widget;
}

function getResolvedSize() {
    const parsedSize = Number(pluginConfig.size);
    if (Number.isFinite(parsedSize) && parsedSize > 0) {
        return Math.max(32, parsedSize);
    }

    return 58;
}

function applyIconSize($icon: HTMLElement | null) {
    if (!$icon) {
        return;
    }

    const iconSize = Math.round(getResolvedSize() * 0.62);
    Object.assign($icon.style, {
        width: `${iconSize}px`,
        height: `${iconSize}px`,
        minWidth: `${iconSize}px`,
        minHeight: `${iconSize}px`,
        maxWidth: `${iconSize}px`,
        maxHeight: `${iconSize}px`
    });
}

function getButtonStyle() {
    const {
        position = "bottom-left",
        offset = [20, 20]
    } = pluginConfig;

    const [offsetX = 20, offsetY = 25] = offset;
    const size = getResolvedSize();

    const centerY = `calc(50% - ${size / 2}px - ${offsetY}px)`;
    const centerX = `calc(50% - ${size / 2}px - ${offsetX}px)`;
    const baseStyle = {
        width: `${size}px`,
        height: `${size}px`
    };

    switch (position) {
        case "bottom-right":
            return {
                ...baseStyle,
                bottom: `${offsetY}px`,
                right: `${offsetX}px`,
                left: "auto"
            };
        case "top-left":
            return {
                ...baseStyle,
                top: `${offsetY}px`,
                left: `${offsetX}px`,
                bottom: "auto"
            };
        case "top-right":
            return {
                ...baseStyle,
                top: `${offsetY}px`,
                right: `${offsetX}px`,
                left: "auto",
                bottom: "auto"
            };
        case "center-left":
            return {
                ...baseStyle,
                left: `${offsetX}px`,
                bottom: centerY
            };
        case "center-right":
            return {
                ...baseStyle,
                right: `${offsetX}px`,
                left: "auto",
                bottom: centerY
            };
        case "bottom-center":
            return {
                ...baseStyle,
                bottom: `${offsetY}px`,
                left: centerX
            };
        case "top-center":
            return {
                ...baseStyle,
                top: `${offsetY}px`,
                bottom: "auto",
                left: centerX
            };
        default: // "bottom-left"
            return {
                ...baseStyle,
                bottom: `${offsetY}px`,
                left: `${offsetX}px`
            };
    }
}
